import { PagerObject } from "../../types/DataFetchingTypes";
import {
    CreateVendorRequest,
    DeleteVendorResponse,
    SpendCategory,
    UpdateVendorRequest,
    Vendor,
    VendorOrderForm,
} from "../../types/VendorTypes";
import { safeDELETE, safeGET, safePOST, safePUT } from "./SafeClient";

// export function listVendors(
//     pageRequest: PageRequest,
//     sorter: Sort[],
//     filter: FilterGroup[],
//     tags?: string[],
//     abort?: any
// ): Promise<PagerObject<Vendor[]>> {
//     const sorting = sorter
//         .map(
//             (v) =>
//                 `sort[]=${v.attribute}&order[]=${v.order}${
//                     v.prefix !== undefined ? "&orderpf[]=" + v.prefix : ""
//                 }`
//         )
//         .reduce((p, v) => `${p}&${v}`, "");
//     const paging = `current=${pageRequest.current}&pageSize=${pageRequest.pageSize}`;
//     const filtering = filter
//         .map((v) => {
//             return v.filter
//                 .map((fv) => {
//                     return `filter[]=${fv.attribute}&operand[]=${fv.operand}&value[]=${fv.value}&group[]=${v.groupId}&gop[]=${v.groupType}`;
//                 })
//                 .join("&");
//         })
//         .reduce((p, v) => `${p}&${v}`, "");

//     let tagQuery = "";
//     if (tags?.length) {
//         tagQuery = tags.map((v) => `tag[]=${v}`).reduce((p, v) => `${p}&${v}`, "");
//     }

//     return safeGET(`/api/vendor?${paging}${sorting}${filtering}${tagQuery}`, abort);
// }

export async function getVendors(vendorIds: string[], abort?: any): Promise<Vendor[]> {
    const ids = vendorIds.reduce((p, v) => `${p}&vendorKey[]=${encodeURIComponent(v)}`, "");
    return safeGET(`/api/vendor/m?${ids}`, abort);
}

export function loadVendorSuggestions(match: string, abort?: any): Promise<Vendor[]> {
    return safeGET(`/api/vendor/s?q=${encodeURIComponent(match)}`, abort);
}

/** Super admin only. The server generates the vendorKey. */
export function createVendor(request: CreateVendorRequest, abort?: any): Promise<Vendor> {
    return safePOST(`/api/vendor`, request, abort);
}

/** Super admin only. Changes the fields present in the request. */
export function updateVendor(request: UpdateVendorRequest, abort?: any): Promise<Vendor> {
    return safePUT(`/api/vendor/${encodeURIComponent(request.vendorKey)}`, request, abort);
}

export function deleteVendor(vendor: Vendor, abort?: any): Promise<DeleteVendorResponse> {
    return safeDELETE(`/api/vendor/${encodeURIComponent(vendor.vendorKey)}`, vendor, abort);
}

/** Every vendor of the org with its deals (order forms with a value or a report). */
export async function getVendorOrderForms(abort?: any): Promise<PagerObject<VendorOrderForm[]>> {
    return safeGET(`/api/vendor/orderform`, abort);
}

export async function getVendorCategories(abort?: any): Promise<SpendCategory[]> {
    return safeGET(`/api/vendor/category`, abort);
}
